import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./Test.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import FreeTestDetail from "./FreeTestDetail";
import girl from "../../images/girl.png";
import loadimg from "../../images/loader_wish.gif";
import { Helmet } from "react-helmet";

function FreeTest({ token, onNavHide, free_test_slug }) {
  const navigate = useNavigate();
  const [testData, setTestData] = useState([]);
  const [BannerImage, setBannerImage] = useState("");
  const [BannerContent, setBannerContent] = useState("");
  const [allQuestions, setAllQuestions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [IsEasterEgg, setIsEasterEgg] = useState(false);
  const [Validate, setValidate] = useState(false);
  const [TestNote, setTestNote] = useState([]);
  const [TestName, setTestName] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [seo, setSeo] = useState({});
  const [TestColor, setTestColor] = useState({});

  const [TestIntro, setTestIntro] = useState(""); 

  const [tieCategories, setTieCategories] = useState([]);

  const [CalculationInfo, setCalculationInfo] = useState(null);

  useEffect(() => {
  
      const FetchCalculation = async () => {

        try {

          const cacheKey = `calculation_${free_test_slug}`;

          const savedCalculation =
            localStorage.getItem(cacheKey);

          if (savedCalculation) {

            const parsed =
              JSON.parse(savedCalculation);

            setCalculationInfo(parsed);

            return;
          }

          const response = await fetch(
            `${END_URL}/calculation/${free_test_slug}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          const data = await response.json();

          setCalculationInfo(data?.data);

          localStorage.setItem(
            cacheKey,
            JSON.stringify(data?.data)
          );

        } catch (error) {

          console.error(
            "Calculation fetch failed",
            error
          );
        }
      };

      if (free_test_slug) {
        FetchCalculation();
      }

    }, [free_test_slug]);


  useEffect(() => {
    const fetchTest = async () => {
      setIsLoading(true);
      try {
        let url = `${END_URL}/fetch/test-random`;
        if (free_test_slug) {
          url += `/${free_test_slug}`;
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const ResponseData = response.data.test.category;

        const QuestionData = response.data.questions;

        const seoDate = response.data.seo_page;

        setSeo(seoDate);
        setTestNote(response.data.test_pop);
        setTestData(ResponseData);
        setBannerImage(response.data?.test?.testdetail?.test_banner);
        setBannerContent(response.data?.free_test_content);
        setTestColor(response.data?.test?.testdetail);

        setTestIntro(response.data?.test?.testinfo);

        // Flatten all questions from all categories
        // const flattenedQuestions = ResponseData.flatMap((category) =>
        //   category.questions.map((question) => ({
        //     ...question,
        //     category_id: category.id,
        //     category_name: category.name,
        //     leftletter: category.leftletter,
        //     rightletter: category.rightletter,
        //     left_label: category.left_label,
        //     right_label: category.right_label,
        //     value: question.value || 50,
        //     result: question.result || 0,
        //     specialquestions: question.specialquestions || "N",
        //     required: question.required || false,
        //     answered: question.answered || false,
        //   }))
        // );

        const flattenedQuestions = QuestionData.flatMap((question) =>
              ({
                  ...question,
                  category_id: question?.category.id,
                  category_name: question?.category.name,
                  leftletter: question?.category.leftletter,
                  rightletter: question?.category.rightletter,
                  left_label: question?.category.left_label,
                  right_label: question?.category.right_label,
                  value: question.value || 50,
                  result: question.result || 0,
                  specialquestions: question.specialquestions || "N",
                  required: question.required || false,
                  answered: question.answered || false,
              })
        );

        setAllQuestions(flattenedQuestions);

        const testDetails = {
          id: response.data.test.id,
          slug: response.data.test.slug,
          name: response.data.test.name,
          type: response.data.test.type,
          result_test_name: response.data.test.result_test_name,
        };
        setTestName(testDetails);
      } catch (error) {
        console.error("Error fetching Test:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTest();
  }, [free_test_slug]);

  const handleResults = (updatedQuestions) => {

    setAllQuestions(updatedQuestions);
  };

  const handleSubmit = async () => {

    const unansweredRequired = allQuestions.filter(
      (q) => q.required === true && q.result === 0
    );

    if (unansweredRequired.length > 0) {
      setValidate(true);
      return;
    }

    const categoryResults = testData.map((category) => {
      const categoryQuestions = allQuestions.filter(
        (q) => q.category_id === category.id
      );

      let leftsum = 0;
      let rightsum = 0;

      categoryQuestions.forEach((question) => {
        if (question.result < 0) {
          leftsum += Math.abs(question.result);
        } else {
          rightsum += question.result;
        }
      });

      const totalquestions =
        100 *
          categoryQuestions.filter((q) => q.specialquestions === "N").length ||
        800;
      const total = leftsum + rightsum;
      const neutral = totalquestions - total;
      const neutralpercent = (neutral / totalquestions) * 100;
      const leftpercent = (leftsum / totalquestions) * 100;
      const rightpercent = (rightsum / totalquestions) * 100;

      if (
        (Math.round(leftpercent) === 50 && Math.round(rightpercent) === 50) ||
        Math.round(leftpercent) === Math.round(rightpercent)
      ) {
        return { tie: true, category_id: category.id };
      }

      if (neutralpercent === 100) {
        return { easterEgg: true, category_id: category.id };
      }

      const letter = leftpercent > rightpercent ? "left" : "right";

      return {
        category_id: category.id,
        name: category.name,
        letter: letter,
        left_result: leftpercent,
        right_result: rightpercent,
        leftletter: category.leftletter,
        rightletter: category.rightletter,
        leftlabel: category.left_label,
        rightlabel: category.right_label,
      };
    });

    const tiedResults = categoryResults.filter((r) => r.tie);

    const hasTie = tiedResults.length > 0;

    setTieCategories(
      tiedResults.map((r) => {
        const category = testData.find(
          (c) => c.id === r.category_id
        );

        return {
          id: r.category_id,
          name: category?.category?.name,
        };
      })
    );


    const hasEasterEgg = categoryResults.some((r) => r.easterEgg);

    if (hasTie) {
      setIsModalOpen(true);
      return;
    }

    if (hasEasterEgg) {
      setIsEasterEgg(true);
      return;
    }

    await SubmitTest(categoryResults);
  };

  const SubmitTest = async (categoryResults) => {

    const result_letter = categoryResults
      .slice()
      .sort((a, b) => a.category_id - b.category_id)
      .map(item =>
        item.letter === "left" ? item.leftletter : item.rightletter
      );

    const slug = TestName.slug;
    const finalResult = result_letter.join("");
    const randomPart = Math.floor(Math.random() * 1e10);
    const test_slug = `${randomPart}-${slug}`;

    console.log('finalResult',finalResult);
    
    const test = {
      data: categoryResults,
      test: TestName,
      result: finalResult,
      test_slug: test_slug,
      slug: slug,
      type: "save_test",
    };

    localStorage.setItem("handle_1", slug);
    localStorage.setItem("handle_2", test_slug);

    const SaveTest = async () => {
      try {
        const response = await axios.post(
          `${END_URL}/submit/test/${slug}/${test_slug}`,
          test,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (CalculationInfo) {
        
          localStorage.setItem(
            `calculation_${free_test_slug}`,
            JSON.stringify(CalculationInfo)
          );
        }

        window.location.href = `${response.data.url}?calculating`;
      } catch (error) {
        console.error("Error sending result:", error);
      }
    };

    if (TestName.type == "free_test") {
      if (token) {
        SaveTest();
      } else {

        if (CalculationInfo) {
        
          localStorage.setItem(
            `calculation_${free_test_slug}`,
            JSON.stringify(CalculationInfo)
          );
        }

        localStorage.setItem(slug, JSON.stringify(test));
        window.location.href = `/result/${slug}/${test_slug}?calculating`;
      }
    } else {
      SaveTest();
    }
  };

const handleModalClose = () => {

  const tiedCategoryIds =
    tieCategories.map((t) => t.id);

  const unlockedQuestionIds = [];

  const updatedQuestions = allQuestions.map((question) => {
    const alreadyUnlockedInCategory =
      unlockedQuestionIds.some((id) => {

        const foundQuestion = allQuestions.find(
          (q) => q.id === id
        );

        return (
          foundQuestion?.category_id ===
          question.category_id
        );
      });

    if (
      tiedCategoryIds.includes(question.category_id) &&
      question.specialquestions === "Y" &&
      !alreadyUnlockedInCategory
    ) {

      unlockedQuestionIds.push(question.id);

      return {
        ...question,
        specialquestions: "N",
        required: true,
        answered: false,
        value: 50,
        result: 0,
        unlocked_by_tie: true,
        active_by_tie: true,
      };
    }

    return question;
  });

  setAllQuestions(updatedQuestions);

  setIsModalOpen(false);

  setTimeout(() => {

    const visibleQuestions = updatedQuestions.filter(
      (q) => q.specialquestions === "N"
    );

    const sections =
      document.getElementsByClassName("test-box1");

    unlockedQuestionIds.forEach((questionId) => {

      const questionIndex =
        visibleQuestions.findIndex(
          (q) => q.id === questionId
        );

      if (sections[questionIndex]) {

        sections[questionIndex].style.opacity = "1";

        sections[questionIndex].style.pointerEvents =
          "auto";

        sections[questionIndex].classList.add(
          "active-tie-question"
        );

        setTimeout(() => {

          sections[questionIndex]?.classList.remove(
            "active-tie-question"
          );

        }, 2500);
      }
    });

    const firstQuestionId =
      unlockedQuestionIds[0];

    const firstQuestionIndex =
      visibleQuestions.findIndex(
        (q) => q.id === firstQuestionId
      );

    if (sections[firstQuestionIndex]) {

      const top =
        sections[firstQuestionIndex]
          .getBoundingClientRect().top +
        window.scrollY -
        120;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }

  }, 300);
};

  const handleEasterEgg = () => {
    setIsEasterEgg(false);
  };

  const handleValidate = () => {
    setValidate(false);
  };

  return (
    <>
      <Helmet>
        <title>
          {seo?.meta_title ||
            "Personality Assessment Test with Models | Personality Peek "}
        </title>
        <meta
          name="description"
          content={
            seo?.meta_description ||
            "Try our free personality assessment test to uncover your traits, strengths, and archetype. Fun, fast, and insight-driven results"
          }
        />
        <meta
          name="keywords"
          content={
            seo?.meta_keywords || "personality assessment test , personality test"
          }
        />
        {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
        {seo?.og_description && (
          <meta property="og:description" content={seo.og_description} />
        )}
        {seo?.og_image && (
          <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
        )}
        {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
        {seo?.og_type && <meta property="og:type" content={seo.og_type} />}
        {seo?.twitter_title && (
          <meta name="twitter:title" content={seo.twitter_title} />
        )}
        {seo?.twitter_description && (
          <meta name="twitter:description" content={seo.twitter_description} />
        )}
        {seo?.twitter_image && (
          <meta
            name="twitter:image"
            content={`${IMG_URL}/d0/${seo.twitter_image}`}
          />
        )}
        {seo?.twitter_card && (
          <meta name="twitter:card" content={seo.twitter_card} />
        )}
        {seo?.og_url && <link rel="canonical" href={seo.og_url} />}
        {!seo?.og_title && (
          <meta
            property="og:title"
            content="PersonalityTest - Discover Your True Archetype | Personality Peek"
          />
        )}
        {!seo?.og_description && (
          <meta
            property="og:description"
            content="Try our free personality assessment test to uncover your traits, strengths, and archetype. Fun, fast, and insight-driven results"
          />
        )}
        {!seo?.og_type && <meta property="og:type" content="website" />}
        {!seo?.twitter_card && (
          <meta name="twitter:card" content="summary_large_image" />
        )}
      </Helmet>

      <div className="test-main">
        {testData && testData.length > 0 && allQuestions.length > 0 && (
          <>
            <FreeTestDetail
              TestColor={TestColor}
              onNavHide={onNavHide}
              testData={testData}
              allQuestions={allQuestions}
              BannerImage={BannerImage}
              BannerContent={BannerContent}
              handleResults={handleResults}
              slug={free_test_slug}
              TestIntro={TestIntro}
            />

            <div className="row test-button-row">
              <a className="test-box-a test-subt" onClick={handleSubmit}>
                <span className="test-box-a-text">Submit</span>
                <span className="test-box-a-icon">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </a>
            </div>
          </>
        )}

        {isModalOpen && (
          <div className="modal-question">
            <div className="modal-test">
              <div className="modal-content-test">
                <div
                  dangerouslySetInnerHTML={{
                    __html: TestNote?.attend_new_question,
                  }}
                />

              {tieCategories.some((item) => item.name) && (
                  <div className="tie-category-list">

                    <p>
                      Tie detected in:
                    </p>

                    <ul>
                      {tieCategories
                        .filter((item) => item.name)
                        .map((item) => (
                          <li key={item.id}>
                            {item.name}
                          </li>
                      ))}
                    </ul>

                  </div>
                )}

                <button
                  className="modal-close-button-test"
                  onClick={handleModalClose}
                >
                  Ok
                </button>
                <img src={girl} alt="" />
              </div>
            </div>
          </div>
        )}

        {IsEasterEgg && (
          <div className="modal-question">
            <div className="modal-test">
              <div className="modal-content-test">
                <p>Easter Egg !</p>
                <button
                  className="modal-close-button-test"
                  onClick={handleEasterEgg}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        )}

        {Validate && (
          <div className="modal-question">
            <div className="modal-test">
              <div className="modal-content-test">
                <p>Please answer all required questions!</p>
                <button
                  className="modal-close-button-test"
                  onClick={handleValidate}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default FreeTest;